<template>
  <div class="group relative mb-6 h-[404px] w-[299px] overflow-hidden md:mb-0 md:w-[272px]" data-testid="story-tall-card">
    <nuxt-link class="no-underline" :to="`/stories/${props.story.id}/`">
      <div class="relative overflow-hidden">
        <OptimizedImage
          :alt="`${props.story.title}の画像`"
          :class="['h-[404px] w-[299px] transition-transform duration-500 group-hover:scale-110 md:w-[272px]']"
          :image-url="props.story.thumbnailImage.url"
          :optimized-image-options="{ width: 560 }"
        />
        <div class="absolute inset-x-0 bottom-0 h-[125px] bg-gradient-to-b from-transparent to-[rgba(51,51,51,0.5)]"></div>
        <div class="absolute bottom-0 px-4 pb-4">
          <div class="mb-1">
            <p class="line-clamp-2 text-sm leading-[22px] tracking-[0.5px] text-white duration-500 group-hover:text-gold2 md:leading-5 md:tracking-[1px]">
              {{ props.story.title }}
            </p>
          </div>
          <div>
            <h3 class="line-clamp-3 text-xl leading-[22px] tracking-[0.5px] text-white duration-500 group-hover:text-gold2 md:text-base md:leading-6 md:tracking-[0.04em]">
              {{ props.story.interviewee }}
            </h3>
          </div>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import { OptimizedImage } from '@/wabunka-src/common/components';
import type { StoryViewModel } from '@/wabunka-src/features/Story/models';

interface Props {
  story: StoryViewModel;
}
const props = defineProps<Props>();
</script>
